<template>
	<div>
		<div class="container">
		    <div class="loop-grid mb-30" v-if="data.length>0">
		        <div class="row">
					<!-- left -->
		            <div class="col-lg-8 mb-30">
		            	
		            		<div class="news-top">
		            			<span class="news-title">Featured News</span>
		            			<div class="button-more" style="cursor: pointer;" @click="tonewsmain">more +</div>
		            		</div>
		                <div class="carausel-post-1 hover-up border-radius-10 overflow-hidden transition-normal position-relative wow fadeInUp animated" :data-wow-delay="0"  @touchstart="touchStart" @touchend="touchEnd">
		            		<div style="display: flex;width: 100%;overflow: hidden;cursor: pointer;">
		            			<div style="display: flex;width: 100%;transition: all 0.2s linear;" :style="{marginLeft:'-'+newsActive*100+'%'}">
		            				<div style="width: 100%;flex: none;" @click="tonewsdetail(item.id)" data-wow-delay="" v-for="(item, newsindex1) in data.slice(0,3)"
		            						:key="newsindex1">
		            				    <div class="position-relative post-thumb">
		            				        <div class="thumb-overlay img-hover-slide position-relative" :style="{backgroundImage: 'url('+item.coverImage+')'}">
		            				            <div class="post-content-overlay text-white ml-30 mr-30 pb-30">
		            				                <div class="entry-meta meta-0 font-small mb-10">
		            									<div class="news-left-box-r-tags">
		            										<div v-for="(tag, index3) in item.tags" :key="index3" style="margin-right: 0.5rem;" :style="{color: colorlist[index3]}">{{tag.name}} .</div>
		            									</div>
		            				                </div>
		            				                <h3 class="post-title font-weight-900 mb-20">
		            				                    <span class="text-white news-title-text">{{item.title}}</span>
		            				                </h3>
		            				                <div class="entry-meta meta-1 font-small text-white mt-10 pr-5 pl-5">
		            				                    <span class="post-on">{{item.createdAt|format}}</span>
		            				                    <span class="hit-count has-dot">{{item.browseCount}} Views</span>
		            				                </div>
		            				            </div>
		            				        </div>
		            				    </div>
		            				</div>
		            			</div>
		            		</div>
		            		
		            		<div style="position: absolute;right: 1rem;bottom: 1rem;display: flex;z-index: 10;">
		            			<!-- <img :src="newsleft==0?require('../../assets/imgs/news-l-btn.png'):require('../../assets/imgs/news-l-btn-light.png')"
		            					style="margin-right: 1rem;width: 2rem;height: 2rem;cursor: pointer;" @click="prenews" @mouseenter="newsleftbtn(1)" @mouseleave="newsleftbtn(0)">
		            			<img :src="newsright==0?require('../../assets/imgs/news-r-btn.png'):require('../../assets/imgs/news-r-btn-light.png')"
		            					style="width: 2rem;height: 2rem;cursor: pointer;" @click="nextnews" @mouseenter="newsrightbtn(1)" @mouseleave="newsrightbtn(0)"> -->
		            			
		            			<div style="width: 0.5rem;height: 0.5rem;border-radius: 50%;margin: 0 0.3rem;cursor: pointer;" v-for="(item,i) in data.slice(0,3)" :key="i" 
		            						:style="{backgroundColor: i==newsActive?'#31ffda':'#a4a4a4'}" @click="clickcircle(i)"></div>
		            		</div>
		                </div>
		            	
		            	<div class="row" style="margin-top: 30px;">
		            		
		            		<article class="col-lg-6 col-md-6 mb-30 wow fadeInUp animated" :data-wow-delay="newsindex2/5+'s'" @click="tonewsdetail(item.id)" style="cursor: pointer;" v-for="(item, newsindex2) in data.slice(3)" :key="newsindex2">
		            		    <div class="post-card-1 border-radius-10 hover-up">
		            		        <div class="post-thumb thumb-overlay img-hover-slide position-relative nomark" :style="{backgroundImage: 'url('+item.coverImage+')'}" >
		            		        </div>
		            		        <div class="post-content p-30">
		            		            <div class="entry-meta meta-0 font-small mb-10">
		            						<div class="news-left-box-r-tags">
		            							<div v-for="(tag, index3) in item.tags" :key="index3" style="margin-right: 0.5rem;" :style="{color: colorlist[index3]}">{{tag.name}} .</div>
		            						</div>
		            		            </div>
		            		            <div class="d-flex post-card-content">
		            		                <h5 class="post-title mb-20 font-weight-900">
		            		                    <span class="news-title-text">{{item.title}}</span>
		            		                </h5>
		            		                <div class="entry-meta meta-1 float-left font-x-small text-uppercase">
		            		                    <span class="post-on">{{item.createdAt|format}}</span>
		            		                    <span class="post-by has-dot">{{item.browseCount}} Views</span>
		            		                </div>
		            		            </div>
		            		        </div>
		            		    </div>
		            		</article>
		            	</div>
		            </div>
					<!-- right -->
					<div class="post-block-list post-module-1 col-lg-4 col-md-6 mb-30">
						
							<div class="news-top">
								<span class="news-title">Latest Information</span>
								<div class="button-more" style="opacity: 0;">more +</div>
							</div>
					    <ul class="list-post">
					        <li class="mb-20 wow fadeInUp animated" :data-wow-delay="index/5+'s'" @click="tonewsdetail(item.id)" v-for="(item, index) in hotData" :key="index">
					            <div class="d-flex bg-white has-border p-25 hover-up transition-normal border-radius-5" style="cursor: pointer;">
					                <div class="post-content media-body">
					                    <h6 class="post-title mb-15 text-limit-2-row font-medium" style="font-size: 1rem;">{{item.title}}</h6>
					                    <div class="entry-meta meta-1 float-left font-x-small text-uppercase">
					                        <!-- <span class="post-on">{{item.createdAt|format}}</span> -->
					                        <span class="post-by">{{item.browseCount}} views</span>
					                    </div>
					                </div>
					                <div class="post-thumb post-thumb-80 d-flex ml-15 border-radius-5 img-hover-scale overflow-hidden" >
					                    <span class="color-white">
					                        <!-- <img :src="hotData.items[0].coverImage" alt=""> -->
										<div  :style="{backgroundImage: 'url('+item.coverImage+')'}"  class="news-img-box"></div>
					                    </span>
					                </div>
					            </div>
					        </li>
					    </ul>
					</div>
		        </div>
		    </div>
		</div>
	</div>
</template>

<script>
	
		import axios from 'axios'
		import {WOW} from 'wowjs'
		import {baseUrl} from '../../assets/js/public.js'
			export default {
				data() {
					return {
						newsActive:0,
						newsleft:0,
						newsright:0,
						data:[],
						hotData:[],
						colorlist:['#01A587', '#8D66F8', '#ED532B', '#D8BE50', '#52A5F7'],
						touchStartX:0,
						touchStartY:0,
						delta: 50,
					}
				},
				components: {
				},
				filters: {
		        },
				methods: {
					clickcircle(i){
						 this.newsActive = i
					},
					touchStart(e) {
						console.log("触摸开始")
						this.touchStartX = e.touches[0].clientX;
						this.touchStartY = e.touches[0].clientY;
					},
					touchEnd(e) {
						console.log("触摸结束")
						let deltaX = e.changedTouches[0].clientX - this.touchStartX;
						let deltaY = e.changedTouches[0].clientY - this.touchStartY;
						console.info('sx',this.touchStartX)
						console.info('ex', deltaX)
						// X轴的滑动距离大于 delta，且此次事件是以X轴移动为主（左滑或者右滑）；
						if (Math.abs(deltaX) > this.delta && Math.abs(deltaX) > Math.abs(deltaY)) {
							if (deltaX >= 0) {
								console.log("右滑")
								this.prenews()
							} else {
								console.log("左滑")
								this.nextnews()
							}
						// Y轴的滑动距离大于 delta，且此次事件是以Y轴移动为主（上滑或者下滑）；
						} else if (Math.abs(deltaY) > this.delta && Math.abs(deltaX) < Math.abs(deltaY)) {
							if (deltaY < 0) {
								console.log("上滑")
							} else {
								console.log("下滑")
							}
						// 两轴位移都特别小，可以判断是点击
						} else if (Math.abs(deltaY) < 25 && Math.abs(deltaX) < 25) {
							console.log("点击")
						} else {
							console.log("可能是误触")
						}
					},
					getData(){
						let perPage = 6
						this.request({
							method: 'get',
							url: '/gci/article/list?perPage='+perPage+'&page=1',
						}).then(res => {
							this.hotData = res.data.items
							this.$nextTick(()=>{
								new WOW().init()
							})
						}).catch(error => {
							console.error(error.response)
						})
					},
					getHotData(){
						let perPage = 5
						this.request({
							method: 'get',
							url: '/gci/article/list?orderBy=isHot&perPage='+perPage,
						}).then(res => {
							this.data = res.data.items
						}).catch(error => {
							console.error(error.response)
						})
					},
					prenews(){
						if(this.newsActive>0){
							this.newsActive--
						}
					},
					nextnews(){
						if(this.newsActive<2){
							this.newsActive++
						}
					},
					newsleftbtn(i){
						this.newsleft = i
					},
					newsrightbtn(i){
						this.newsright = i
					},
					tonewsdetail(id){this.$router.push({name:'newsdetail', query:{id:id}})},
					tonewsmain(){this.$router.push({name:'newsmain'})}
				},
				mounted() {
					this.getData()
					this.getHotData()
				}
			}
	
</script>

<style scoped lang="scss">
	li{list-style:none}
	.slide-fade{
		
	}
		.news-top{
			margin: 50px 0 30px;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.button-more{
			width: 80px;
			height: 36px;
			background: #D4F9F3;
			border-radius: 47px 47px 47px 47px;
			font-size: 0.9rem;
			font-weight: 500;
			color: #000000;
			line-height: 0px;
			
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.button-more:hover{
			background: linear-gradient(270deg, #23F8D2 0%, #23F7D3 49%, #23E4EB 100%);
		}
		.news-title{
			flex: 1;
			font-size: 26px;
			font-weight: 500;
			color: #000;
			line-height: 0px;
		}
		.news-banner{
			width: 100%;
			/* height: 745px; */
			background: #FFFFFF;
			border-radius: 20px 20px 20px 20px;
			opacity: 1;
			/* border: 1px solid #707070; */
			margin-top: 22px;
		}
		.news-img{
			width: 100%;
			height: 250px;
			
		}
		.news-right{
			margin-top: 32px;
		}
		.news-text{
			font-size: 22px;
		}
		.news-text-item{
			font-size: 14px;
		}
		.post-card-1:hover{
			.post-title{
				color: #00E8BE;
				text-decoration: underline;
			}
		}
		.news-img-box{
			background-size:cover;
			background-repeat: no-repeat;
			background-position: top center ;
			width: 5.625rem;
		    height: 5rem;
			transition: transform .5s;
		}
		.news-img-box:hover{
			-webkit-transform: scale(1.1);
			-ms-transform: scale(1.1);
			transform: scale(1.1);
			-webkit-transition: -webkit-transform .5s;
			transition: -webkit-transform .5s;
			-o-transition: transform .5s;
			transition: transform .5s;
			transition: transform .5s,-webkit-transform .5s;
		}
		.news-title-text{
			display: initial;
			-webkit-line-clamp: 3;
			-webkit-box-orient: vertical;
			text-overflow: ellipsis;
			overflow: hidden;
			display: -webkit-box;
		}
		.news-left-box-r-tags{
			font-size: 0.7rem;
			margin-top: 0.5rem;
			display: flex;
			flex-wrap: wrap;
		}
		.nomark::before{
			background:none;
		}
</style>